import { forwardRef } from "react";
function SvgRawEditIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="#0052C4"
        strokeWidth={2}
        d="M10.333 2.333a1.414 1.414 0 0 1 2 2l-7 7h-1.98l-.02-2 7-7Z"
        clipRule="evenodd"
      />
      <path
        stroke="#0052C4"
        strokeWidth={2}
        d="M2.667 14h10.666M9.335 3.333l1.998 2"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawEditIcon);
export default ForwardRef;
